import { render, staticRenderFns } from "./crudTasks.vue?vue&type=template&id=ad8b8988&"
import script from "./crudTasks.vue?vue&type=script&lang=js&"
export * from "./crudTasks.vue?vue&type=script&lang=js&"
import style0 from "./crudTasks.vue?vue&type=style&index=0&id=ad8b8988&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports